import React from 'react';

// components
import TableTop from '../../../../core/table/TableTop';
import TableHead from '../../../../core/table/TableHead';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import Button from '../../../../core/components/Button';
import SaveToExcelButton from '../../../../core/table/actions/SaveToExcelButton';

// hooks
import { useIraListStore } from '../pagehooks/useIraListStore';
import { useIraListTableInit } from './useIraListTableInit';
import { useIraListTableState } from './useIraListTableState';
import { useIraData } from './useIraData';
import { useIraListImport } from '../import/useIraListImport';

import { IRA_LIST_TABLE_ID } from '../../ira_const';

// get excel
import iraRepo from '../../data/iraRepo';
import { HttpErrorIgnore } from '../../../../../global';
const EXCEL_FILE_NAME = 'Verity-IraPayorList';
const onGetExcel = (): Promise<HttpErrorIgnore | undefined> => iraRepo.getExcel(EXCEL_FILE_NAME);

// import
import IraImportFlyOut from '../import/IraImportFlyOut';
import TableList from '../../../../core/table/TableList';

const IraListTable = (): JSX.Element => {
    const { init } = useIraListTableInit();

    if (init) {
        return <></>;
    }

    return (
        <>
            <TableWrapper />
            <IraImportFlyOut />
        </>
    );
};

const TableWrapper = (): JSX.Element => {
    const { canEdit, loading } = useIraListStore();
    const { showImport } = useIraListImport();

    const { waiting, fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, setWait } =
        useIraListTableState();
    const { items } = useIraData();

    if (waiting || loading) {
        return <></>;
    }

    return (
        <TableList>
            <TableTop
                id={IRA_LIST_TABLE_ID}
                fltStats={fltStats}
                topRight={
                    <>
                        <SaveToExcelButton
                            waiting={waiting}
                            setWait={setWait}
                            onGetExcel={onGetExcel}
                        />
                        {canEdit ? (
                            <Button
                                id="iraImport"
                                onClick={showImport}
                            >
                                Import
                            </Button>
                        ) : null}
                    </>
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default IraListTable;
